import React, { useEffect, useMemo, useRef, useState } from "react";
import "../styles/CustomImageUpload.css";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { Button } from "reactstrap";
import { toast } from "react-toastify";

export default function CustomImageUpload({
  value = null,
  onChange,
  placeholder = "Select Image",
  isOpenUpload = false,
}) {
  const imageRef = useRef();
  const imageRef2 = useRef();
  const [crop, setCrop] = useState({
    unit: "px",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
  });
  const [showCropping, setShowCropping] = useState(false);

  const handleImageChange = (e) => {
    const file = e.target.files?.[0] ?? null;
    if (file) {
      const reader = new FileReader();

      reader.onload = function (event) {
        const img = new Image();
        img.onload = function () {
          const width = img.width;
          if (width >= 200) {
            onChange(file);
            setShowCropping(true);
          } else {
            toast.error("Image must atleast have a size of 200 x 200");
          }
        };
        img.src = event.target.result;
      };

      reader.readAsDataURL(file);
    }
  };

  const getImageUrl = useMemo(() => {
    return !value
      ? "#"
      : typeof value === "string"
      ? value
      : URL.createObjectURL(value);
  }, [value]);

  const doCrop = () => {
    if (![crop?.width, crop?.height, crop?.x, crop?.y].includes(undefined)) {
      const canvas = document.createElement("canvas");
      const image = imageRef2.current;

      let scaleFactor = 1;
      if (image.height > 500 || image.width > 500) {
        scaleFactor = Math.max(image.width, image.height) / 500;
      }

      canvas.width = scaleFactor * crop.width;
      canvas.height = scaleFactor * crop.height;
      const ctx = canvas.getContext("2d");

      ctx.drawImage(
        image,
        scaleFactor * crop.x,
        scaleFactor * crop.y,
        scaleFactor * crop.width,
        scaleFactor * crop.height,
        0,
        0,
        scaleFactor * crop.width,
        scaleFactor * crop.height
      );
      canvas.toBlob((res) => {
        const file = new File([res], "filename.png", { type: "image/png" });
        onChange(file);
        setShowCropping(false);
      });
      setCrop({
        unit: "px",
        x: 0,
        y: 0,
        width: 100,
        height: 100,
      });
    }
  };

  useEffect(() => {
    if (isOpenUpload) {
      imageRef.current.click();
    }
  }, [isOpenUpload]);

  return (
    <>
      <input
        type="file"
        name="logo"
        accept=".png, .jpg, .jpeg"
        ref={imageRef}
        placeholder="upload"
        onChange={handleImageChange}
        className="d-none"
      />
      <img src={getImageUrl} ref={imageRef2} style={{ display: "none" }} />
      <div
        className="custom-image-upload-preview"
        style={{
          backgroundImage: `url('${getImageUrl}')`,
        }}
        onClick={() => {
          imageRef.current.click();
        }}
      >
        {!value && placeholder}
      </div>

      {showCropping ? (
        <div className="custom-image-upload-container">
          <div className="custom-image-upload-wrapper">
            <ReactCrop
              crop={crop}
              onChange={(c) => setCrop(c)}
              style={{
                maxHeight: "500px",
                maxWidth: "500px",
                width: "fit-content",
                margin: "auto",
              }}
            >
              <img src={getImageUrl} />
            </ReactCrop>
            <div className="custom-image-upload-buttons-container">
              <Button color="white" onClick={() => setShowCropping(false)}>
                No need to crop?
              </Button>
              <Button color="primary" onClick={() => doCrop()}>
                Crop
              </Button>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
